import { render, staticRenderFns } from "./Estadistica.vue?vue&type=template&id=4a88a744&"
import script from "./Estadistica.vue?vue&type=script&lang=js&"
export * from "./Estadistica.vue?vue&type=script&lang=js&"
import style0 from "./Estadistica.vue?vue&type=style&index=0&id=4a88a744&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports